import $ from 'jquery'
export default {
    name: 'ordonnances',
    components: {},
    props: [
        "consultation_id", "protocole_id", "prescriptions", "hn", 
        "etat_traitement", "p_soignant", "jn", "can_show_empty"
    ],
    data() {
        return {
            is_loading: true,
            is_empty: false,

            to_be_deleted: {},
            del_loading: false,
            is_confirm: false,
        }
    },

    watch: {
        prescriptions() {
            this.getListePrescription()
        }
    },

    computed: {
        /**
         * User Info
         * @returns
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },
    },

    mounted() {
        this.getListePrescription()
    },

    methods: {
        getListePrescription() {
            this.is_loading = true
            if (this.prescriptions.length > 0) {
                this.is_empty = false
            } else {
                this.is_empty = true
            }
            setTimeout(() => {
               this.is_loading = false 
            }, 500);
        },

        deletePrescripion(p) {
            this.to_be_deleted = {
                id: parseInt(p.prescription_id),
                medicament: p.medicament
            }
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
        onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }
            let data = {
                prescription_id: this.to_be_deleted.id
            }

            console.log(data)
            this.$store.dispatch('deletePrescriptionForHn', data).then((response) => {
                if (response > 0) {
                    this.successToast("Médicament supprimé avec succès")
                    this.$emit('emitProtocole', this.jn)

                    this.is_confirm = false
                    this.$refs.prescriptionDelModal.click();
                }
                this.del_loading = false
            }).catch((err) => {
                console.log("ERROR CATCH: ", err)
                this.del_loading = false
            })
        },
    }
}


